<template>
  <el-select class="agent-select title-tool" v-model="selected" placeholder="데이터가 없습니다.">
    <el-option v-for="agent in agentList" :key="agent.value" :label="agent.objName" :value="agent.objId" />
  </el-select>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

export default {
  name: 'WE2eAgentComobox',
  props: {
    agentList: {
      type: Array,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    agentList: {
      immediate: true,
      handler(value) {
        if (isEmpty(value)) {
          this.selected = null;
        } else {
          this.selected = value[0].objId;
        }
      },
    },
    selected: {
      handler(value) {
        if (!isNil(value)) {
          this.$emit('change', value);
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/components/E2eAgentCombobox.vue